module.exports = __webpack_public_path__ + "img/img37.d7ac90f2.png";